import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { StackedChartComponent } from './stacked.component';

@NgModule({
  entryComponents: [
    StackedChartComponent
  ],
  imports: [
    TranslateModule,

    NgxChartsModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule,

    FlexLayoutModule
  ],
  declarations: [
    StackedChartComponent
  ],
  exports: [
    StackedChartComponent
  ]
})
export class StackedChartModule {}
